import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["collapse", "questionItem", "content", "icon"]
  
  connect() {
    
    // まず基本的な要素の存在確認
    const allQContent = document.querySelectorAll('.q-content')
    
    const thisQContent = this.element.querySelectorAll('.q-content')
    
    // すべての.q-contentにTailwindの初期クラスを設定
    this.initializeQContent()
    
    // Turbo対応のために少し待ってからハンドラーを設定
    setTimeout(() => {
      this.setupHandlers()
    }, 100)
  }

  initializeQContent() {
    const qContents = this.element.querySelectorAll('.q-content')
    
    qContents.forEach(content => {
      // 既存のクラスをクリア（q-contentは残す）
      const existingClasses = content.className.split(' ').filter(cls => cls === 'q-content')
      content.className = existingClasses.join(' ')
      
      // Tailwindの初期クラスを追加
      content.className += ' absolute top-12 left-full w-0 h-0 opacity-0 overflow-hidden transition-all duration-500 ease-out'
      content.style.backgroundColor = '#a2e7be'
      
    })
  }

  disconnect() {
  }

  setupHandlers() {
    this.setupCollapsibleHandlers()
    this.setupQuestionHandlers()
  }

  setupCollapsibleHandlers() {
    // h3[data-target] のクリックハンドラー（data-toggle="collapse"を削除したため）
    const collapsibleHeaders = this.element.querySelectorAll('h3[data-target]')
    
    
    collapsibleHeaders.forEach(header => {
      header.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()
        
        // Bootstrapのdata-target を取得
        const targetSelector = header.getAttribute('data-target')
        const targetElement = document.querySelector(targetSelector)
        
        const icon = header.querySelector('i')
        if (icon) {
          if (icon.classList.contains('fa-angle-double-down')) {
            icon.classList.remove('fa-angle-double-down')
            icon.classList.add('fa-angle-double-up')
            
            // コンテンツを表示
            if (targetElement) {
              targetElement.classList.add('show', 'in')
              targetElement.style.display = 'block'
            }
          } else {
            icon.classList.remove('fa-angle-double-up')
            icon.classList.add('fa-angle-double-down')
            
            // コンテンツを非表示
            if (targetElement) {
              targetElement.classList.remove('show', 'in')
              targetElement.style.display = 'none'
              
              // このセクション内の開いているq-contentも一緒に閉じる
              const openedQContent = targetElement.querySelector('.q-content.on')
              if (openedQContent) {
                openedQContent.classList.remove('on')
                
                // Tailwindクラスを削除して非表示状態に戻す
                openedQContent.className = openedQContent.className.replace(/(?:^|\s)(?:fixed|relative|absolute|top-\d+|left-\d+|right-\d+|bottom-\d+|w-\w+|h-\w+|opacity-\d+|z-\d+|overflow-\w+|bg-\w+-\d+|transition|duration-\d+)(?:\s|$)/g, ' ').trim()
                
                // 元の非表示状態のTailwindクラスを追加
                openedQContent.className += ' absolute top-12 left-full w-0 h-0 opacity-0 overflow-hidden transition-all duration-500 ease-out'
                openedQContent.style.backgroundColor = '#a2e7be'
                
                // スクロールも復元
                if (window.innerWidth < 992) {
                  this.enableScroll()
                }
              }
            }
          }
        }
      })
    })
  }

  setupQuestionHandlers() {
    // .q ul.list-unstyled li のクリックハンドラー
    
    // デバッグ用：様々なセレクターを試してみる
    const allQElements = this.element.querySelectorAll('.q')
    
    const allUlElements = this.element.querySelectorAll('.q ul')
    
    const allListElements = this.element.querySelectorAll('.q ul li')
    
    const questionItems = this.element.querySelectorAll('.q ul.list-unstyled li[data-target]')
    
    // より広いセレクターも試してみる
    const allDataTargetItems = this.element.querySelectorAll('li[data-target]')
    
    questionItems.forEach((item, index) => {
      
      // CSS的にクリック可能にする + グレー背景を設定
      item.style.pointerEvents = 'auto'
      item.style.cursor = 'pointer'
      item.style.userSelect = 'none'
      
      // 最も重要：visibility と display を強制的に有効にする
      item.style.visibility = 'visible'
      item.style.display = 'list-item'
      item.style.width = 'auto'
      item.style.height = 'auto'
      item.style.overflow = 'visible'
      
      // グレー背景を設定
      item.style.backgroundColor = '#f5f5f5'  // ライトグレー
      item.style.border = ''
      item.style.padding = ''
      item.style.margin = ''
      item.style.position = ''
      item.style.zIndex = ''
      
      
      // クリックイベントハンドラー
      item.addEventListener('click', (event) => {
        this.handleQuestionClick(item, event)
      })
    })

    // .q-close のクリックハンドラー
    const closeButtons = this.element.querySelectorAll('.q-close')
    
    
    closeButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault()
        
        const targetId = button.getAttribute('data-target')
        const target = document.getElementById(targetId)
        
        if (target) {
          target.classList.remove('on')
          
          // Tailwindクラスを削除して非表示状態に戻す
          target.className = target.className.replace(/(?:^|\s)(?:fixed|relative|absolute|top-\d+|left-\d+|right-\d+|bottom-\d+|w-\w+|h-\w+|opacity-\d+|z-\d+|overflow-\w+|bg-\w+-\d+|transition|duration-\d+)(?:\s|$)/g, ' ').trim()
          
          // 元の非表示状態のTailwindクラスを追加
          target.className += ' absolute top-12 left-full w-0 h-0 opacity-0 overflow-hidden transition-all duration-500 ease-out'
          target.style.backgroundColor = '#a2e7be'
          
          
          if (window.innerWidth < 992) {
            this.enableScroll()
          }
        }
      })
    })
  }

  smoothScrollTo(element, offset = 0) {
    const elementPosition = element.offsetTop
    const offsetPosition = elementPosition - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }

  disableScroll() {
    document.body.style.overflow = 'hidden'
  }

  enableScroll() {
    document.body.style.overflow = ''
  }

  // no_scroll関数の代替
  no_scroll() {
    this.disableScroll()
  }

  // return_scroll関数の代替
  return_scroll() {
    this.enableScroll()
  }

  // 質問項目クリック時の処理
  handleQuestionClick(item, event) {
    event.preventDefault()
    event.stopPropagation()
    
    const targetId = item.getAttribute('data-target')
    const target = document.getElementById(targetId)
    const returnPoint = item.getAttribute('data-return')
    
    if (target && !target.classList.contains('on')) {
      // すべての 'on' クラスを削除
      document.querySelectorAll('.q-content.on').forEach(el => {
        el.classList.remove('on')
      })
      
      target.classList.add('on')
      
      // Tailwindクラスで表示状態にする
      target.className = target.className.replace(/(?:^|\s)(?:absolute|top-\d+|left-\w+|w-\d+|h-\d+|opacity-\d+|overflow-\w+)(?:\s|$)/g, ' ').trim()
      target.className += ' fixed top-0 left-0 w-full h-full opacity-100 overflow-auto bg-white z-50 transition-all duration-500 ease-out'
      
      // 背景色を元の緑色に戻す
      target.style.backgroundColor = '#a2e7be'
      
      // スクロール処理は削除（スクロール位置を維持）
      if (window.innerWidth < 992) {
        this.disableScroll()
      }
    } else if (target && target.classList.contains('on')) {
    } else {
    }
  }
}
